import {History} from '../../../graphql-typings/graphql';
import {PeriodFunction} from './period-function';
import {AccumulatingChartFunction, FunctionName} from './chart-function-types';
import {IterableUtil} from '@app/shared/util/collections/collection-utils';

export interface SumContext {
  sum: number | null;
}

export class SumFunction extends PeriodFunction implements AccumulatingChartFunction<SumContext> {

  constructor() {
    super(FunctionName.SUM, 'Sum');
  }

  run(historyArray: History[], padValues?: boolean): History[] {
    return this.applyPeriodFunction(historyArray, (ha: History[]) => this.getAggregate(this.accumulate(ha, null)), padValues);
  }

  accumulate(history: Iterable<History>, context: SumContext | null): SumContext {
    let sum: number | null = context?.sum ?? null;
    IterableUtil.forEach(history, historyItem => {
      sum = (sum ?? 0) + historyItem.data;
    });
    const newContext: SumContext = {...context, sum};
    return newContext;
  }

  getAggregate(context: SumContext): number {
    return context.sum;
  }
}
